/**
 * @generated SignedSource<<a08b6b667a2136e88aa32c22c93cbd76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithTopModule_shoppingWith$data = {
  readonly description: string | null;
  readonly mainImage: string | null;
  readonly mobileImage: string | null;
  readonly subTitle: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithLinks_shoppingWith" | "ShoppingWithMobileDescription_shoppingWith" | "ShoppingWithSocial_shoppingWith">;
  readonly " $fragmentType": "ShoppingWithTopModule_shoppingWith";
};
export type ShoppingWithTopModule_shoppingWith$key = {
  readonly " $data"?: ShoppingWithTopModule_shoppingWith$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithTopModule_shoppingWith">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShoppingWithTopModule_shoppingWith",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShoppingWithSocial_shoppingWith"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShoppingWithMobileDescription_shoppingWith"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShoppingWithLinks_shoppingWith"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subTitle",
      "storageKey": null
    }
  ],
  "type": "ShoppingWith",
  "abstractKey": null
};

(node as any).hash = "c97b0454846163acab71e2a7a0fce794";

export default node;
